import { createSlice } from "@reduxjs/toolkit";
import { getDishesAPI } from "../../api/dishes";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const getDishesSlice = createSlice({
  name: "getDishes",
  initialState: data,
  reducers: {
    getDishesSlice(state) {
      state.isLoading = true;
    },
    getDishesSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getDishesSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getDishesSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getDishesHandler =
  (
    search: any,
    page: any,
    limit: any,
    selectedStatus: any,
    sort_by: any,
    sort_direction: any,
    created_by: any
  ) =>
  async (dispatch: any) => {
    try {
      dispatch(getDishesAction.getDishesSlice());
      const response: any = await getDishesAPI(
        search,
        page,
        limit,
        selectedStatus,
        sort_by,sort_direction,
        created_by
      );

      dispatch(getDishesAction.getDishesSliceSuccess(response));
    } catch (e: any) {
      dispatch(getDishesAction.getDishesSliceFailure(e?.response?.data));
    }
  };
export default getDishesSlice.reducer;
export const getDishesAction = getDishesSlice.actions;
